import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { TextField, Button, MenuItem, Box, Typography, } from '@mui/material';
import { GroupApi } from '../../../apis';


// Validation schema using Yup
const validationSchema = Yup.object({
    name: Yup.string().required('Name is required'),
    description: Yup.string().required('Description is required'),
    status: Yup.string().required('Status is required'),
});

function MyForm({ fetchGroups, close }) {
    const [loading, setLoading] = useState(false);
    const formik = useFormik({
        initialValues: {
            name: '',
            description: '',
            status: 'active',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            try {
                setLoading(true);
                // Make the API call to create a project
                let res = await GroupApi.createGroup(values);
                if (res.status === 200) {
                    await fetchGroups();  // Ensure this function runs
                    close();
                }
            } catch (error) {
                console.error('Error creating project:', error);
                // Handle the error, e.g., show a notification or alert
            } finally {
                setLoading(false);
            }
        },
    });


    return (
        <Box
            component="form"
            onSubmit={formik.handleSubmit}
            sx={{
                '& .MuiTextField-root': { mb: 2 },
                // maxWidth: 400,
                padding: '20px',
                margin: 'auto',
            }}
        >
            <Typography variant="h7" component="div" gutterBottom>
                Name
            </Typography>
            <TextField
                fullWidth
                id="name"
                name="name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name}
            />

            <Typography variant="h7" component="div" gutterBottom>
                Description
            </Typography>
            <TextField
                fullWidth
                id="description"
                name="description"
                multiline
                rows={3}
                value={formik.values.description}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.description && Boolean(formik.errors.description)}
                helperText={formik.touched.description && formik.errors.description}
            />

            <Typography variant="h7" component="div" gutterBottom>
                Status
            </Typography>
            <TextField
                fullWidth
                id="status"
                name="status"
                select
                value={formik.values.status}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.status && Boolean(formik.errors.status)}
                helperText={formik.touched.status && formik.errors.status}
            >
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="inactive">Inactive</MenuItem>
            </TextField>



            <Button color="primary" variant="contained" fullWidth type="submit" disabled={loading}>
                Submit
            </Button>
        </Box>
    );
}

export default MyForm;
